import * as _ from 'lodash'
import { MessageType } from '../PA.Core/PA.Core.IF.Basic'
import {
    WB_FinishedProductRelationshipRow,
    WB_WorkflowStatusRow
} from '../PA.Core/PAdbSchemaRows'
import { DateUtils } from '../PA.Core/Basic/Dates'
import { WorkflowBO } from './WorkflowBO'


export class WorkflowBOValidations {


    static ValidateEmptyFields(aBO: WorkflowBO): Promise<void> {

        return new Promise((resolve, error) => {
            if (!aBO.drWB_Workflow.isActive)
                resolve()

            if (_.isEmpty(aBO.WB_Workflow.cif.WORKFLOW_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyId',
                        type: MessageType.Error,
                        title: 'WorkFlow ID cannot be empty',
                        description: '',
                        subtitle: '',
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }

            if (_.isEmpty(aBO.WB_Workflow.cif.WORKFLOW_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyName',
                        type: MessageType.Error,
                        title: 'Work Flow Name cannot be empty',
                        description: '',
                        subtitle: '',
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyName')
            }

            if (_.isEmpty(aBO.WB_Workflow.cif.WORKFLOW_USAGE)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'usage',
                        type: MessageType.Error,
                        title: 'Work Flow Usage cannot be empty',
                        description: '',
                        subtitle: '',
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('usage')
            }

            let bstatusid = false
            let bstatusname = false
            let bstatustype = false
            let bDomId = false
            let bStatusNext = false
            let bStatus = false

            _.forEach(_.filter(aBO.WB_Workflow.WB_WorkflowStatusRows, (x: WB_WorkflowStatusRow) => x.isActive), (aRow) => {

                    _.forEach(aRow.WB_WorkflowStatusRelationshipRows, function(aRelRow) {
                        if (!aRow.isActive) {
                            return
                        }

                        if (_.isUndefined(aRelRow.cif.WB_DOMITEM_ID) || _.isNull(aRelRow.cif.WB_DOMITEM_ID)) {
                            bDomId = true
                        }
                        if (_.isUndefined(aRelRow.cif.WB_STATUS_ID_NEXT) || _.isNull(aRelRow.cif.WB_STATUS_ID_NEXT)) {
                            bStatusNext = true
                        }
                        if (_.isUndefined(aRelRow.cif.WB_STATUS_ID) || _.isNull(aRelRow.cif.WB_STATUS_ID)) {
                            bStatus = true
                        }
                    })

                    if (_.isEmpty(aRow.cif.STATUS_ID)) {
                        bstatusid = true
                    }

                    if (_.isEmpty(aRow.cif.STATUS_NAME)) {
                        bstatusname = true
                    }

                    if (_.isEmpty(aRow.cif.STATUS_TYPE)) {
                        bstatustype = true
                    }
                }
            )

            // Add here TODO

            if (bDomId) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'domid',
                        type: MessageType.Error,
                        title: 'Role  can not be empty',
                        description: '',
                        subtitle: '',
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('domid')

            }

            if (bStatusNext) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'StatusNext',
                        type: MessageType.Error,
                        title: 'Status Next cannot be empty',
                        description: '',
                        subtitle: '',
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('StatusNext')

            }

            if (bStatus) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'status',
                        type: MessageType.Error,
                        title: 'Status cannot be empty',
                        description: '',
                        subtitle: '',
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('status')

            }
            if (bstatusid) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'statusid',
                        type: MessageType.Error,
                        title: 'Status ID cannot be empty',
                        description: '',
                        subtitle: '',
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('statusid')

            }

            if (bstatusname) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'statusname',
                        type: MessageType.Error,
                        title: 'Status Name cannot be empty',
                        description: '',
                        subtitle: '',
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('statusname')

            }

            if (bstatustype) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'statustype',
                        type: MessageType.Error,
                        title: 'Status Type cannot be empty',
                        description: '',
                        subtitle: '',
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('statustype')

            }
            resolve()
        })
    }
}